import { Injectable } from "@angular/core";
import { CustomCellState } from "../models/diagram.models";
import { CellState, Graph, ImageBox, ImageShape, Rectangle } from "@maxgraph/core";
import { DIAGRAM_BUTTONS } from "../models/diagram.constants";
import { AnyDrawCommand, CustomEdgeParameters } from "@nms-ng2/app/shared/services/layout-manager/drawing.models";

/**
 * Construtor de layout customizado de elementos.
 */
@Injectable({
    providedIn: "root"
})
export abstract class CustomElementLayoutBuilder {

    static insertDeleteButton(graph: Graph, cellState: CellState, command: AnyDrawCommand) {
        const deleteButton = DIAGRAM_BUTTONS.DELETE;
        const deleteImage = new ImageBox(deleteButton.imagePath, deleteButton.width, deleteButton.height);
        const customState = (cellState as CustomCellState);

        const bounds = new Rectangle(0, 0, deleteImage.width, deleteImage.height);
        customState.deleteControl = new ImageShape(bounds, deleteImage.src);
        customState.deleteControl.dialect = graph.dialect;
        customState.deleteControl.preserveImageAspect = false;
        customState.deleteControl.setCursor("pointer");

        graph.getCellRenderer().initControl(cellState, customState.deleteControl, false, function (evt) {
            const edgeParameters = command.parameters as CustomEdgeParameters;

            edgeParameters.custom?.onRemove.call(null, command);
        });
    }

    /**
     * Reposiciona o eixo X dos links para evitar sobreposição no diagrama.
     * @param state - Estado da célula
     * @param offset - offset para calcular a nova posição.
     * @param xPoints - Pontos do link que o X deve ser alterado.
     */
    static repositionLinkXAxis(state: CustomCellState, offset: number, xPoints: number[]) {
        xPoints.forEach((pointIndex) => {
            state.absolutePoints[pointIndex].x += offset;
        });
    }

    /**
     * Reposiciona links internos para que não sigam exatamente os mesmos pontos e sejam ambos visíveis separadamente.
     * @param state - Estado da célula
     * @param yCellTarget - Elemento alvo para calcular a posição Y do link.
     * @param offset - offset para calcular a nova posição.
     * @param yPoints - Pontos do link que o Y deve ser alterado.
     */
    static repositionLinkYAxis(state: CustomCellState, yCellTarget: CellState, offset: number, yPoints: number[]) {
        const newYPosition = CustomElementLayoutBuilder.getNewYElementAxis(yCellTarget, offset);

        yPoints.forEach((pointIndex) => {
            state.absolutePoints[pointIndex].y = newYPosition;
        });
    }

    private static getNewYElementAxis(cellState: CellState, offset: number): number {
        return cellState.y + offset;
    }

}
